module.exports = __webpack_public_path__ + "img/3_30.f1a248cf.png";